import { render, staticRenderFns } from "./BodyPractical.vue?vue&type=template&id=3941e2c0"
import script from "./BodyPractical.vue?vue&type=script&lang=js"
export * from "./BodyPractical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports